import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

// 引入路由
import monitorRoutes from '@/router/business/monitor'

export default {
  path: 'visualization',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '数据可视化',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [
    workbenchServiceDict.PURCHASER.value,
    workbenchServiceDict.AGENCY.value
  ],
  roles: [
    platformFunctionModuleDict.QUERY_STATS.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: monitorRoutes.children[0].children.filter(
    route =>
      route.meta.title === '数据大屏' || route.meta.title === '采购驾驶舱'
  )
}
